export default __webpack_public_path__ + "static/media/charu.a0ab6458.png";